<div class="card">
	<p-dataView #dv [value]="medias" [paginator]="true" [rows]="12" filterBy="name" layout="grid" alwaysShowPaginator="false">
		<ng-template pTemplate="header">

			<div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
				<div class="flex align-items-center justify-content-center h-4rem font-bold m-2">
					<p-dataViewLayoutOptions></p-dataViewLayoutOptions>
				</div>
			</div>
		</ng-template>
		<ng-template let-media pTemplate="listItem">
			<div class="p-col-12">
				<div class="product-list-item grid">
					<div class="col-3 list-container-image">
						<p-image [preview]="true" *ngIf="media.type === 'IMAGE'" src="{{media.resource_url}}"></p-image>
						<img *ngIf="media.type === 'VIDEO'" class="thumb-video" (click)="openEvidence(media)" src="{{media.thumb_url}}">
					</div>
					<div class="col-9 product-list-detail">
						<div class="product-name">{{media.name}}</div>
						<div class="product-description">{{media.description}}</div>
					</div>
				</div>
			</div>
		</ng-template>
		<ng-template let-media pTemplate="gridItem">
			<div class="p-col-12 p-med-2 p-lg-2">
				<div class="product-grid-item card">
					<div class="product-grid-item-content">
						<p-image [preview]="true" *ngIf="media.type === 'IMAGE'" class="grid-image" src="{{media.resource_url}}"></p-image>
						<img *ngIf="media.type === 'VIDEO'" class="thumb-video" (click)="openEvidence(media)" src="{{media.thumb_url}}">
						<div class="product-name">{{media.name}}</div>
					</div>
				</div>
			</div>
		</ng-template>
	</p-dataView>
</div>

<p-galleria [(value)]="images" [(visible)]="displayEvidence" [responsiveOptions]="responsiveOptions" [containerStyle]="{'max-width': '850px'}" [numVisible]="7"
    [circular]="true" [fullScreen]="true" [showItemNavigators]="true" [showThumbnails]="false" [baseZIndex]="100000">
    <ng-template pTemplate="item" let-item>
        <img [src]="item.resource_url" style="width: 100%; display: block;"/>
    </ng-template>
    <ng-template pTemplate="thumbnail" let-item>
        <div class="grid grid-nogutter justify-content-center">
            <img [src]="item.resource_url" style="display: block;"/>
        </div>
    </ng-template>
	<ng-template pTemplate="caption" let-item>
        <h4 style="margin-bottom: .5rem; color: #ffffff;">{{item.title}}</h4>
        <h3>{{item.name}}</h3>
    </ng-template>
</p-galleria>
